import { useEffect } from "react";
import { BrowserRouter } from "react-router-dom";
import classNames from "classnames";
import { AppRoutes } from "routes";
import { useAppSelector, useAppDispatch } from "hooks";
import { useGetThemePreferenceQuery } from "services/theme";
import { setTheme } from "state/reducers/themeSlice";
import GoogleAnalyticsProvider from "GoogleAnalyticsProvider";
import {layout_types} from "./state/reducers/layoutSlice";
import { IframeModalManager } from "components/organisms/IframeModalManager";
import "./styles/main.scss";

function App() {
  const { isLoading, isError, data } = useGetThemePreferenceQuery();
  const dispatch: any = useAppDispatch();
  const { mode } = useAppSelector(
    (state: { theme: { mode: "light" | "dark" } }) => state.theme
  );
  const { layoutMode } = useAppSelector(
      (state: { layout: { layoutMode: layout_types } }) => state.layout
  );

  useEffect(() => {
    if (!isLoading && !isError) {
      if (data && data.Theme) {
        dispatch(setTheme(data.Theme));
      }
    }
  }, [data]);

  return (
    <BrowserRouter>
      <GoogleAnalyticsProvider>
        <div className={classNames(`theme-${mode}`, layoutMode)}>
          <AppRoutes theme={mode} />
          <IframeModalManager />
        </div>
      </GoogleAnalyticsProvider>
    </BrowserRouter>
  );
}

export default App;
